const review = {
  /**
   * 审核通过
   * @param {string} id
   */
  reviewPassed (id) {
    this.indexes[id].answer.isPassed = '20'
    this.indexes[id].answer.errorMessage = ''
  },

  /**
   * 审核不通过
   * @param {string} id
   * @param {string} errorMessage
   */
  reviewNotPassed (id, errorMessage) {
    this.indexes[id].answer.isPassed = '30'
    this.indexes[id].answer.errorMessage = errorMessage
  },

  /**
   * 清空已审核结果
   * @param {string} id
   */
  emptyReviewed (id) {
    if (this.indexes[id].answer.isPassed !== '10') {
      this.indexes[id].answer.isPassed = '10'
    }
    if (this.indexes[id].answer.errorMessage !== '') {
      this.indexes[id].answer.errorMessage = ''
    }
  },

  /**
   * 是否已审核
   * @param {string} id
   */
  isReviewed (id) {
    return this.indexes[id].answer.isPassed !== '10'
  },

  /**
   * 审核通过
   * @param {string} id
   */
  isPassed (id) {
    return this.indexes[id].answer.isPassed === '20'
  },

  /**
   * 审核不通过
   * @param {string} id
   */
  isNotPassed (id) {
    return this.indexes[id].answer.isPassed === '30'
  },

  /**
   * 验证题目的答案是否合法
   * 多选填空题验证
   * 输入框验证
   * @param id
   */
  validateAnswer (id) {
    let question = this.indexes[id].data
    let answer = this.indexes[id].answer
    if (question.type === 'text') {
      // 需要对输入框进行验证
      if (question.inputType === 'numberInt') {
        if (!new RegExp('^[0-9]*$').test(answer.text)) {
          return false
        }
      }
      if (question.inputType === 'numberFloat') {
        if (!(/^\d+(\.\d+)?$/.test(answer.text) || new RegExp('^[0-9]*$').test(answer.text))) {
          return false
        }
      }
      return !!answer.text
    } else if (['select', 'multiselect', 'imageMultiselect'].includes(question.type)) {
      return answer.selectedOptionId.length > 0
    } else if (question.type === 'multitext') {
      for (let i = 0; i < question.options.length; i++) {
        // 验证输入内容
        if (!this.validateMultitextValue(question.options[i], answer.texts[i])) {
          return false
        }
      }
    }
    return true
  }
}

export default review



// WEBPACK FOOTER //
// ./src/views/question-review/review/review.js